var _circle, _circle2, _circle3, _line, _line2, _line3, _circle4, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSyncroIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "faviconGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#4F46E5",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#7C3AED",
      stopOpacity: 1
    }
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 20,
    r: 8,
    fill: "url(#faviconGradient)",
    opacity: 0.9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 42,
    r: 8,
    fill: "url(#faviconGradient)",
    opacity: 0.9
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 42,
    r: 8,
    fill: "url(#faviconGradient)",
    opacity: 0.9
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 20,
    x2: 18,
    y2: 42,
    stroke: "url(#faviconGradient)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 20,
    x2: 46,
    y2: 42,
    stroke: "url(#faviconGradient)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 42,
    x2: 46,
    y2: 42,
    stroke: "url(#faviconGradient)",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 7,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 28.5 32 L 32 27.5 L 35.5 32 L 32 36.5 Z",
    fill: "url(#faviconGradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncroIcon);
export default __webpack_public_path__ + "static/media/syncro_icon.f4546dba9bb34a540f781083eb4a1b2e.svg";
export { ForwardRef as ReactComponent };